import React from 'react';
import { Box, Typography, Paper, Divider } from '@mui/material';
import SentimentDissatisfiedIcon from '@mui/icons-material/SentimentDissatisfied';
import { VChainerFooter } from './components/VChainerFooter';
import { useAppSelector } from './hooks';
import { selectSettings } from '../features/settings/settingsSlice';
import { LanguageToggle } from './components/LanguageToggle';

const texts = {
  title: {
    pl: 'Link stracił ważność',
    en: 'The link has expired',
    de: 'Der Link ist abgelaufen',
  },
  description: {
    pl: `Dziękujemy za skorzystanie z naszego systemu V-Chainer.
         Wygląda na to, że link, z którego próbujesz skorzystać, jest już nieaktywny lub wygasł.
         Zespół V-Chainer dba o bezpieczeństwo i komfort użytkowników.
         Linki są ważne tylko przez ograniczony czas, by chronić Twoje dane.`,
    en: `Thank you for using our V-Chainer system.
         It seems the link you’re trying to use is either inactive or has expired.
         The V-Chainer team cares about your safety and comfort.
         Links are only valid for a limited time to protect your data.`,
    de: `Vielen Dank, dass Sie V-Chainer nutzen.
         Der Link, den Sie öffnen möchten, ist nicht mehr aktiv oder bereits abgelaufen.
         Ihre Sicherheit ist uns wichtig. Zum Schutz Ihrer Daten sind Links nur für begrenzte Zeit gültig.`,
  },
  supportNote: {
    pl: 'Jeżeli potrzebujesz pomocy, skontaktuj się z naszym zespołem wsparcia.',
    en: 'If you need help, please contact our support team.',
    de: 'Wenn Sie Hilfe benötigen, wenden Sie sich bitte an unser Support-Team.',
  },
};


const ExpiredLinkPanel: React.FC = () => {
  const { locale } = useAppSelector(selectSettings);
  const lang = locale === 'en-US' ? 'en' : locale;


  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
      bgcolor="#f4f6f8"
      p={2}
    >
      <Paper elevation={4} sx={{ p: 5, maxWidth: 600, borderRadius: 3, textAlign: 'center', position: 'relative' }}>
        <Box sx={{ position: 'absolute', top: 16, right: 16 }}>
          <LanguageToggle />
        </Box>

        <SentimentDissatisfiedIcon sx={{ fontSize: 64, color: 'warning.main', mb: 2 }} />

        <Typography variant="h5" gutterBottom>
          {texts.title[lang]}
        </Typography>

        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
          {texts.description[lang]}
        </Typography>

        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          {texts.supportNote[lang]}
        </Typography>

        <Divider />
        <VChainerFooter />
      </Paper>
    </Box>
  );
};

export default ExpiredLinkPanel;